import styled from 'styled-components'

export const Grid = styled.div`
    margin: 5px 0;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 14px;
    align-items: center;
`






// WEBPACK FOOTER //
// ./src/modules/mappings/components/builder/Builder_styled.ts